import { Cetacean } from '@/apollo/queries/cetaceans/cetaceans';
import { GET_HOME_DATA, HomeResponse } from '@/apollo/queries/home/home';
import { FIND_NEWS, New, News } from '@/apollo/queries/news/news';
import { Settings } from '@/settings';
import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit
{
    cetaceanOfTheWeek: Cetacean[] | undefined;
    
    news: New[] | undefined;

    backendUrl: string = Settings.backEndUrl;

    introContent: string;

    constructor(private apollo: Apollo)
    {
        // Intro
        this.introContent = "Bienvenue sur le site officiel de <br><b>Mon École, Ma Baleine</b>";
    }

    ngOnInit(): void
    {
        this.apollo.query<HomeResponse>({ query: GET_HOME_DATA }).subscribe(result =>
        {
            this.cetaceanOfTheWeek = result.data.home.cetaceans;
        });

        // Les 4 dernières news
        this.apollo.query<News>({ query: FIND_NEWS, variables: { limit: 4 }}).subscribe(result => 
        {
            this.news = result.data.news;
        });
    }
}
